import { Input } from "components/ui/input";
import React, { useEffect, useRef } from "react";

interface input {
    query: string;
    enabled: boolean;
    page: number;
    limit: number;
}

interface Props {
    input: input;
    setInput: React.Dispatch<React.SetStateAction<input>>;
    callbackFunction: () => Promise<void>;
}

const DinamicSearchBar = ({ input, setInput, callbackFunction }: Props) => {
    const debounceInput = useRef<NodeJS.Timeout | null>(null);

    const handleInputChangeDebounce = () => {
        if (debounceInput.current) clearTimeout(debounceInput.current);
        if (input.query === "") {
            setInput({ ...input, page: 1 });
            callbackFunction();
            return;
        }
        debounceInput.current = setTimeout(async () => {
            setInput({ ...input, page: 1 });
            callbackFunction();
        }, 1000);
    };

    useEffect(() => {
        handleInputChangeDebounce();
    }, [input.query]);

    return (
        <div translate="no" className="relative ">
            <Input
                value={input.query}
                onChange={(e) =>
                    setInput({
                        ...input,
                        query: e.target.value,
                    })
                }
                name="query"
                id="query"
                className="pl-10 border-2 rounded-lg border-blue-consulta-200 "
                placeholder="Buscar"
            />
            <span className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <svg
                    className="w-6 h-6 text-blue-consulta-500"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    strokeWidth="2"
                    stroke="currentColor"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round">
                    {" "}
                    <path stroke="none" d="M0 0h24v24H0z" />{" "}
                    <circle cx="10" cy="10" r="7" />{" "}
                    <line x1="21" y1="21" x2="15" y2="15" />
                </svg>
            </span>
        </div>
    );
};

export default DinamicSearchBar;
